import { rest } from 'msw'
import { Card } from 'services/CardService'

const CARDS_URL = `${process.env.API_URL}/card/v1/cards`

const mockCards = [
  {
    id: '123e4567-e89b-12d3-a456-426614174000',
    customerId: 'cust_123456',
    assetCode: 'USD',
    last4Digits: '1234',
    status: 'ACTIVE',
    createdAt: '2023-12-01T10:00:00Z',
    updatedAt: '2023-12-01T10:00:00Z',
    expiresAt: '2025-12',
    limit: {
      configured: {
        type: 'DAILY',
        value: 1000,
      },
      available: 500,
      nextResetAt: '2023-12-02T00:00:00Z',
    },
    cardTransactionStats: {
      latestAuthorizedAt: '2023-12-01T10:00:00Z',
    },
  },
  {
    id: '223e4567-e89b-12d3-a456-426614174001',
    customerId: 'cust_123456',
    assetCode: 'EUR',
    last4Digits: '5678',
    status: 'FROZEN',
    createdAt: '2023-11-15T09:00:00Z',
    updatedAt: '2023-12-01T08:00:00Z',
    expiresAt: '2026-06',
    limit: {
      configured: {
        type: 'MONTHLY',
        value: 5000,
      },
      available: 2500,
      nextResetAt: '2024-01-01T00:00:00Z',
    },
    cardTransactionStats: {
      latestAuthorizedAt: '2023-11-30T14:22:00Z',
    },
  },
]

const mockCardTransactions = [
  {
    id: '019cf78f-79ea-7997-a84a-32e96c13d44c',
    cardProviderTransactionId: 'a7e9eeec-c057-46ab-a34c-2326f9dbe638',
    cardId: '19726679-a84d-4121-8862-e26d9c39cb41',
    cardNumberLast4Digits: '0698',
    authorizedAmount: 1.34,
    settledAmount: 1.34,
    asset: 'USDC',
    ledgerProviderTransactionIds: {
      SETTLEMENT: ['019cf78f-79ea-7000-a842-352958704238'],
      AUTHORIZATION: ['019cf78f-79ea-7000-8000-00006727f859'],
    },
    status: 'SETTLED',
    createdAt: '2026-03-16T16:51:41.162Z',
    updatedAt: '2026-03-16T16:52:37.857795Z',
    cardProviderTransactionLogs: [],
    metadata: {
      merchantCategory: 'Shoes',
      merchantName: 'EUR Merchant',
      merchantCategoryCode: '5661',
      merchantCity: 'Sofia',
      merchantCountry: 'Bu',
      localCurrency: 'eur',
      localAmount: 1.13,
      usdAmount: 1.34,
    },
    reportData: {
      interchangeAmount: 0,
      fxFee: 0,
      isThreeDSecureTransaction: false,
      isInternationalTransaction: true,
    },
  },
  {
    id: '019b30a1-0c86-7fd3-8e2f-d4caec2c3a2f',
    cardProviderTransactionId: '845e5b4d-37c4-44af-95ea-d565f88e53d5',
    cardId: '19726679-a84d-4121-8862-e26d9c39cb41',
    cardNumberLast4Digits: '0698',
    authorizedAmount: 0,
    settledAmount: 1,
    asset: 'USDC',
    ledgerProviderTransactionIds: {
      SETTLEMENT: ['a67a7260-dbed-11f0-8c86-e1c591284deb'],
    },
    status: 'SETTLED',
    createdAt: '2025-12-18T08:43:39.526Z',
    updatedAt: '2025-12-18T08:43:39.787069Z',
    cardProviderTransactionLogs: [],
    metadata: {
      merchantName: 'Pawel BVNK',
      merchantCategoryCode: 'Shop',
      localCurrency: 'usd',
      localAmount: 1,
      usdAmount: 1,
    },
  },
  {
    id: '019ae4db-18cd-7f69-8104-153cfaadce48',
    cardProviderTransactionId: 'd08e5867-a50e-4298-97e3-d8b4e1be32a3',
    cardId: 'c34dedd8-b649-4562-9fcc-48a0e97521f6',
    cardNumberLast4Digits: '5120',
    authorizedAmount: 0,
    settledAmount: 0,
    asset: 'USDC',
    ledgerProviderTransactionIds: {
      REVERSAL: ['c1fa07d0-d05d-11f0-98cd-ffffeeaeae34'],
      AUTHORIZATION: ['c1fa07d0-d05d-11f0-98cd-00006727f859'],
    },
    status: 'DECLINED',
    createdAt: '2025-12-03T15:35:55.341Z',
    updatedAt: '2025-12-03T15:35:56.586440Z',
    cardProviderTransactionLogs: [],
    metadata: {
      merchantCategory: 'Shop - Shopping',
      merchantName: 'Google',
      merchantCategoryCode: 'Shop',
      localCurrency: 'usd',
      localAmount: 6,
      usdAmount: 6,
    },
    formattedDeclineReason: 'The transaction exceeds a card spending limit.',
  },
  {
    id: '019ae4da-171d-7ec1-9c4d-bd859409d91b',
    cardProviderTransactionId: 'e122e327-ee42-4213-827c-af69871bd90d',
    cardId: 'c34dedd8-b649-4562-9fcc-48a0e97521f6',
    cardNumberLast4Digits: '5120',
    authorizedAmount: 0,
    settledAmount: 0,
    asset: 'USDC',
    status: 'DECLINED',
    createdAt: '2025-12-03T15:34:49.373Z',
    updatedAt: '2025-12-03T15:34:50.627521Z',
    cardProviderTransactionLogs: [],
    metadata: {
      merchantCategory: 'XXXX - Finance',
      merchantName: 'Pawel BVNK',
      merchantCategoryCode: 'XXXX',
      localCurrency: 'usd',
      localAmount: 22,
      usdAmount: 22,
    },
    formattedDeclineReason: 'Transaction declined',
  },
  {
    id: '019ae48b-5646-7e14-9c2c-0787109e3101',
    cardProviderTransactionId: '2ffb8e95-7324-4880-b42d-e10a8da5afe3',
    cardId: 'c34dedd8-b649-4562-9fcc-48a0e97521f6',
    cardNumberLast4Digits: '5120',
    authorizedAmount: 0,
    settledAmount: 0,
    asset: 'USDC',
    status: 'DECLINED',
    createdAt: '2025-12-03T14:08:48.198Z',
    updatedAt: '2025-12-03T14:08:49.520053Z',
    cardProviderTransactionLogs: [],
    metadata: {
      merchantCategory: '- Finance',
      merchantName: 'Pawel BVNK',
      merchantCategoryCode: '',
      localCurrency: 'usd',
      localAmount: 120,
      usdAmount: 120,
    },
    formattedDeclineReason: 'Transaction declined',
  },
]

export const buildCardsHandler = (cards: Card[]) =>
  rest.get(CARDS_URL, (_req, res, ctx) =>
    res(
      ctx.json({
        content: cards,
        pageable: { pageNumber: 0, pageSize: 50 },
        totalElements: cards.length,
      })
    )
  )

export const cardsErrorHandler = rest.get(CARDS_URL, (_req, res, ctx) => res(ctx.status(500)))

export const cardsInfiniteDelayHandler = rest.get(CARDS_URL, (_req, res, ctx) =>
  res(ctx.delay('infinite'))
)

export const buildUpdateCardStatusHandler = (card: Card) =>
  rest.patch(`${CARDS_URL}/:cardId/status`, async (req, res, ctx) => {
    const body = await req.json<{ newStatus: Card['status']; reason?: string }>()
    return res(ctx.json({ ...card, status: body.newStatus }))
  })

export const MOCK_UPDATE_CARD_STATUS_TRACE_ID = 'trace-id-12345'

export const updateCardStatusErrorHandler = rest.patch(
  `${CARDS_URL}/:cardId/status`,
  (_req, res, ctx) => res(ctx.status(500), ctx.json({ traceId: MOCK_UPDATE_CARD_STATUS_TRACE_ID }))
)

const cardHandlers = [
  rest.get(CARDS_URL, (req, res, ctx) => {
    const q = req.url.searchParams.get('q') || ''
    const pageNumber = Number(req.url.searchParams.get('pageNumber')) || 0
    const pageSize = Number(req.url.searchParams.get('pageSize')) || 50

    const customerIdMatch = q.match(/customerId:([^\s]+)/)
    const customerId = customerIdMatch ? customerIdMatch[1].replaceAll('\\', '') : ''

    const filtered = customerId
      ? mockCards.filter(card => card.customerId === customerId)
      : mockCards

    const startIndex = pageNumber * pageSize
    const endIndex = startIndex + pageSize
    const paginated = filtered.slice(startIndex, endIndex)

    return res(
      ctx.json({
        content: paginated,
        pageable: {
          pageNumber,
          pageSize,
        },
        totalElements: filtered.length,
      })
    )
  }),
  rest.get(`${process.env.API_URL}/card/v1/transactions`, (req, res, ctx) => {
    const pageNumber = Number(req.url.searchParams.get('pageNumber')) || 0
    const pageSize = Number(req.url.searchParams.get('pageSize')) || 10

    const startIndex = pageNumber * pageSize
    const endIndex = startIndex + pageSize
    const paginatedContent = mockCardTransactions.slice(startIndex, endIndex)

    return res(
      ctx.json({
        content: paginatedContent,
        pageable: {
          pageNumber,
          pageSize,
        },
        totalElements: mockCardTransactions.length,
      })
    )
  }),
]

export default cardHandlers
